import { SiteLayout } from "@/components/site/site-layout";
import { useCurrentPageOverride } from "@/hooks/use-page-override";

export function PageHero({ eyebrow, title, sub }: { eyebrow: string; title: string; sub: string }) {
  const { data } = useCurrentPageOverride();
  const finalEyebrow = data?.hero_eyebrow || eyebrow;
  const finalTitle = data?.hero_title || title;
  const finalSub = data?.hero_sub || sub;
  return (
    <section className="relative pt-24 pb-16 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-hero-glow opacity-60" />
      {data?.cover_url && (
        <div
          className="absolute inset-0 -z-20 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url(${data.cover_url})` }}
        />
      )}
      <div className="mx-auto max-w-5xl px-4 lg:px-8 text-center">
        <div className="text-xs font-semibold uppercase tracking-widest text-primary">{finalEyebrow}</div>
        <h1 className="mt-3 text-4xl sm:text-6xl font-bold tracking-tight">{finalTitle}</h1>
        <p className="mt-5 max-w-2xl mx-auto text-muted-foreground">{finalSub}</p>
      </div>
    </section>
  );
}

export function PageShell({ children }: { children: React.ReactNode }) {
  return <SiteLayout>{children}</SiteLayout>;
}
